import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const token = localStorage.getItem("jwtToken");
    // If not authenticated, redirect to login
    return token ? <>{children}</> : <Navigate to="/login" replace />;
};

export default PrivateRoute;
